import { Range, Position, DiagnosticSeverity } from 'vscode-languageserver-types';
import { lint, GreyCatLintError } from '@greycat/lang';
var GreyCatValidation = /** @class */ (function () {
    function GreyCatValidation() {
        this._settings = {
            lint: true,
            lintOptions: {
                strict: true,
            },
        };
    }
    GreyCatValidation.prototype.doValidation = function (doc, gcr, settings) {
        var _this = this;
        if (settings === void 0) { settings = this._settings; }
        var diag = [];
        if (settings && settings.lint === true) {
            diag.push.apply(diag, gcr.parseErrors.map(function (e) { return _this._toDiagnostic(e); }));
            if (gcr.cst) {
                var errors = lint(gcr.cst, settings.lintOptions).errors;
                diag.push.apply(diag, errors.map(function (e) { return _this._toDiagnostic(e); }));
            }
        }
        return diag;
    };
    GreyCatValidation.prototype._toDiagnostic = function (e) {
        var range;
        var severity = DiagnosticSeverity.Error;
        if (e instanceof GreyCatLintError) {
            switch (e.severity) {
                case 'error':
                    severity = DiagnosticSeverity.Error;
                    break;
                case 'info':
                    severity = DiagnosticSeverity.Hint;
                    break;
                case 'warning':
                    severity = DiagnosticSeverity.Warning;
                    break;
            }
            range = Range.create(Position.create(e.range.startLine, e.range.startColumn), Position.create(e.range.endLine, e.range.endColumn));
        }
        else {
            var token = e.token ? e.token : e.previousToken;
            range = Range.create(Position.create(token.startLine, token.startColumn), Position.create(token.endLine, token.endColumn));
        }
        return {
            range: range,
            message: e.message,
            severity: severity,
        };
    };
    return GreyCatValidation;
}());
export default GreyCatValidation;
//# sourceMappingURL=gc-validation.js.map